import React, { createContext, ReactNode, useContext, useState } from 'react';
import {
  ApiResponseType,
  ICheckUserName,
  ICheckUserNameResponse,
  IForgotPasswordOtpValidate,
  IForgetPassword,
  IForgetPasswordResponse,
  IGetUserNames,
  ILogin,
  ILoginResponse,
  IOtpVerification,
  IOtpVerificationResponse,
  IRegisterUser,
  IRegisterUserResponse,
  IResendOtp,
  IResetPassword,
  IResetPasswordResponse, IChangePassword,
  IRegisterUserOld,
} from './ContextType';
import axiosInstance from '../api';
import { useCustomToast } from './CustomToastContext';
import { path } from '../constants';
import {  userdata } from '../lib/utils';
import axios from 'axios';


type IAuthContext = {
  registerUser: (data: IRegisterUser) => Promise<ApiResponseType<IRegisterUserResponse>>;
  getUserNames: (data: IGetUserNames) => Promise<ApiResponseType<ICheckUserNameResponse>>;
  checkUserNameAvailability: (data: ICheckUserName) => Promise<ApiResponseType<ICheckUserNameResponse>>;
  loginUser: (data: ILogin) => Promise<ApiResponseType<ILoginResponse>>;
  otpVerification: (data: IOtpVerification) => Promise<ApiResponseType<IOtpVerificationResponse>>;
  resendOtp: (data: IResendOtp) => Promise<ApiResponseType<IOtpVerificationResponse>>;
  forgetPassword: (data: IForgetPassword) => Promise<ApiResponseType<IForgetPasswordResponse>>;
  resetForgotPassword: (data: IResetPassword) => Promise<ApiResponseType<IResetPasswordResponse>>;
  forgotPasswordOtpValidate: (data: IForgotPasswordOtpValidate) => Promise<ApiResponseType<IResetPasswordResponse>>;
  changePassword: (data: IChangePassword) => Promise<ApiResponseType<IForgetPasswordResponse>>;
  logoutUser: () => Promise<ApiResponseType<IResetPasswordResponse>>;
  isLoading: boolean;
  userNames?: string[];
  handle2FA: (data: IResendOtp,endPoint:string) => Promise<ApiResponseType<IOtpVerificationResponse>>;
  registerUserOld:(data:IRegisterUserOld)=> Promise<ApiResponseType<IRegisterUserResponse>>;  
  checkRefer:(data:any)=>any



};

const AuthContext = createContext<IAuthContext | undefined>(undefined);

type IAuthProviderProps = {
  children: ReactNode;
};
 
export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useTheme must be used within a AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const user=userdata
  const { setMessage } = useCustomToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userNames, setUserNames] = useState<string[]>([]);

  const registerUser = async (data: IRegisterUser): Promise<ApiResponseType<IRegisterUserResponse>> =>  {
    try {
      setIsLoading(true);
      const { userName, email, mobileNumber, password, countryCode, lastName,fullName,userFrom } = data;
      const payload:any = {
        fullname: fullName,
        email: email,
        password: password,
        userFrom:userFrom
      }
    
     

      if(data?.utm_object!=undefined){

        payload.utm_object=data?.utm_object

      }
      if(data?.referral_code){
        payload.referral_code=data?.referral_code
        payload.refer_user_id=data?.refer_user_id 

      }

      
      const response = await axiosInstance.post('/user/v2/create', payload,{headers:{"x-user-agent":JSON.stringify(userdata)}});
      localStorage.setItem('userId', response?.data?.userId);
      return {
        success: true,
        data: response.data,
        message: response.data.message
      }
    } catch (e: any) {
      console.log({e})

      setIsLoading(false);
      if(typeof e?.response?.data?.message == 'string'){
        setMessage({
          text: e.response.data.message,
          show: true,
          success: false
        })
      }else{
        
        let errorValues= e.response?.data?.message?.fieldErrors ?Object.values(e.response?.data?.message?.fieldErrors).flatMap(errors => errors):Object.values(e.response?.data?.message?.email).flatMap(errors => errors);
        errorValues.forEach((value:any,index:number,arr:unknown[]):void=>{ 
         
          if(typeof value ==='string'){

            setMessage({
            text: value,
            show: true,
            success: false
          })
          }
      }
      )
      }
      
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setIsLoading(false);
    }
  }

  const registerUserOld = async (data: IRegisterUserOld): Promise<ApiResponseType<IRegisterUserResponse>> =>  {
    try {
      setIsLoading(true);
      const { userName, email, mobileNumber, firstName, password, countryCode, lastName } = data;
      const payload:any = {
        firstName: firstName,
        lastName: lastName,
        userName: userName,
        preferredName: userName,
        email: email,
        password: password,
        mobileNumber: mobileNumber,
        countryCode: countryCode,
      }
      if(data?.utm_object!=undefined){

        payload.utm_object=data?.utm_object

      }
      const response = await axiosInstance.post('/user/create', payload);
      localStorage.setItem('userId', response?.data?.userId);
      return {
        success: true,
        data: response.data,
        message: response.data.message
      }
    } catch (e: any) {

      setIsLoading(false);
      if(typeof e.response.data.message == 'string'){
        setMessage({
          text: e.response.data.message,
          show: true,
          success: false
        })
      }else{
        
        let errorValues= e.response?.data?.message?.fieldErrors ?Object.values(e.response?.data?.message?.fieldErrors).flatMap(errors => errors):Object.values(e.response?.data?.message?.email).flatMap(errors => errors);
        errorValues.forEach((value:any,index:number,arr:unknown[]):void=>{ 
         
          if(typeof value ==='string'){

            setMessage({
            text: value,
            show: true,
            success: false
          })
          }
      }
      )
      }
      
      return {
        success: false,
        message: e.response?.data?.message,
      };
    } finally {
      setIsLoading(false);
    }
  }
const checkRefer=async(values:any)=>{ 
  try{
    if(values?.reffer){ 
      let res = await axios.post(`${process.env.REACT_APP_LEGION_BASE_URL}referral/v1/validate-referral-code`,{referralCode:values?.reffer})
      if(res?.data?.success===true){
       
         return {
          success: true,
          data: res.data,
          message: res.data.message
        }
      

      }

    }

  }catch(e:any){
    return {
      success: false,
      message: e.response.data.message
    }
  }
}
    const getUserNames = async (data: IGetUserNames): Promise<ApiResponseType<ICheckUserNameResponse>> =>  {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post('/user/get-usernames', data);
      setUserNames(response.data.userNames)
      return {
        success: true,
        data: response.data,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  }

  const checkUserNameAvailability = async (data: ICheckUserName): Promise<ApiResponseType<ICheckUserNameResponse>> =>  {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post('/user/check-username-availability', data);
      return {
        success: true,
        data: response.data,
        message: response.data
      }
    } catch (e: any) {
      setIsLoading(false);
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  }

  const loginUser = async (data: ILogin): Promise<ApiResponseType<ILoginResponse>> => {
    try {
      setIsLoading(true);
     console.log('payload===',{data}) 
     
      // @ts-ignore
      const response = await axiosInstance.post('/login', data,{headers:{"x-user-agent":JSON.stringify(userdata)}});
       console.log(JSON.stringify(response))

     
      if(response?.data?.verifyIdentifier){
        localStorage.setItem('user_to_be_verified', response?.data?.userId);
        localStorage.setItem('email_to_be_verified', response?.data?.maskedEmail);
        
        return {
          success: true,
          data: response?.data,
          message: response?.data?.message
        }
      }else if(response?.data?.maskedIdentifier){
        localStorage.setItem('user_to_be_verified', response?.data?.userId);
        localStorage.setItem('email_to_be_verified', response?.data?.maskedIdentifier);
        localStorage.setItem('2fa', 'yes');
        localStorage.setItem('flow',response?.data?.flow)


      }else{

        localStorage.setItem('access_token', response?.data?.access_token);
        localStorage.setItem('refresh_token', response?.data?.refresh_token);
      }
      return {
        success: true,
        data: response?.data?.result,
        message: response?.data?.message
      }
    } catch (e: any) {
      console.log('login===>',{e})
      setIsLoading(false);
      setMessage({
        text: e?.response?.data?.message,
        show: true,
        success: false
      })
      return {
        success: false,
        message: e?.response?.data?.message
      }
    } finally {
      setIsLoading(false);
    }
  }

  const otpVerification = async (data: IOtpVerification): Promise<ApiResponseType<IOtpVerificationResponse>> => {
    try {
      setIsLoading(true);
    

      const response = await axiosInstance.post('/login/verify/otp', data,{headers:{"x-user-agent":JSON.stringify(userdata)}});
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      })
      return {
        success: true,
        data: response.data,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  }
 

  const resendOtp = async (data: IResendOtp): Promise<ApiResponseType<IOtpVerificationResponse>> => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post('/login/otp/resend', data);
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      })
      return {
        success: true,
        data: response.data.userId,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  }
 

  const handle2FA=async(data:IResendOtp,endPoint:string):Promise<ApiResponseType<IOtpVerificationResponse>>=>{
    try {
      setIsLoading(true);
   

      const response = await axiosInstance.post(endPoint, data,{headers:{"x-user-agent":JSON.stringify(userdata)  }});
      if(endPoint==='/login/2fa/verify'){
        localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
      }
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      })
      return {
        success: true,
        data: response.data.userId,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }

  }

  const changePassword = async (data: IChangePassword): Promise<ApiResponseType<IForgetPasswordResponse>> => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post('/login/change-password', data);
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      })
      return {
        success: true,
        data: response.data.otp,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  }

  const forgetPassword = async (data: IForgetPassword): Promise<ApiResponseType<IForgetPasswordResponse>> => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post('/login/forgot-password', data);
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      })
      return {
        success: true,
        data: response.data.otp,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  }

  const forgotPasswordOtpValidate = async (data: IForgotPasswordOtpValidate): Promise<ApiResponseType<IResetPasswordResponse>> => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post('/login/forgot-password/otp/validate', data);
      localStorage.setItem('token', response.data.token);
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      });
      return {
        success: true,
        data: response.data.token,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response?.data?.message
      }
    } finally {
      setIsLoading(false);
    }
  }

  const resetForgotPassword = async (data: IResetPassword): Promise<ApiResponseType<IResetPasswordResponse>> => {
    try {
      setIsLoading(true);
      const { password, tokenHash } = data;
      const payload = {
        password: password,
      }
      const response = await axiosInstance.post('/user/reset-forgot-password/validate', payload,
        { headers: { Authorization: `Bearer ${tokenHash}`}});
      localStorage.removeItem('token');
      setMessage({
        text: response.data.message,
        show: true,
        success: true,
      });
      return {
        success: true,
        data: response.data.result,
        message: response.data.message
      }
    } catch (e: any) {
      setIsLoading(false);
      setMessage({
        text: e.response.data.message,
        show: true,
        success: false,
      })
      return {
        success: false,
        message: e.response?.data?.message,
      }
    } finally {
      setIsLoading(false);
    }
  }

  const logoutUser = async (): Promise<ApiResponseType<IResetPasswordResponse>> => { 
    try {
      setIsLoading(true);
      const response = await axiosInstance.get('/login/session/destroy');
      localStorage.clear();
      return {
        success: true,
        data: response.data,
        message: response.data.message
      }
    } catch (e: any) {
      if (e.response.data.statusCode === 401) {
        window.location.href = path.LOGIN;
        localStorage.clear();
      }
      setIsLoading(false)
      return {
        success: false,
        message: e.response?.data?.message || 'Please try again!'
      }
    } finally {
      setIsLoading(false)
    }
  }

  const contextValue: IAuthContext = {
    userNames: userNames,
    registerUser,
    getUserNames,
    checkUserNameAvailability,
    loginUser,
    otpVerification,
    resendOtp,
    forgetPassword,
    resetForgotPassword,
    forgotPasswordOtpValidate,
    changePassword,
    logoutUser,
    isLoading,
  handle2FA,
  registerUserOld,
  checkRefer

  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  )
}
